import * as constants from './constants';

export const vehicleInitialState = {
  all: null,
  hasDevice: null,
  hasRobot: null,
  information: null,
  details: {},
};

const vehicleReducer = (
  state = vehicleInitialState,
  { type, payload } = {},
) => {
  switch (type) {
    case constants.GET_VEHICLE_DATA:
      return {
        ...state,
        ...payload,
      };
    case constants.GET_VEHICLE_INFORMATION:
      return {
        ...state,
        information: payload,
      };
    case constants.GET_VEHICLE_DETAILS:
      return {
        ...state,
        details: { ...state.details, ...payload },
      };
    case constants.UPDATE_VEHICLE:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};

export default vehicleReducer;
